// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { AnyAction, reducers } from "@insite/client-framework/Store/Reducers";
import { ShippingDetailsModel } from "@tps/XDL/types";
import { Draft } from "immer";

export type xShippingDetailsType = {
    isLoading: boolean;
    isUpdating: boolean;
    warehousesShippingDetails: { [warehouseId: string]: ShippingDetailsModel | null }; // any
};

const initialState: xShippingDetailsType = {
    isLoading: false,
    isUpdating: false,
    warehousesShippingDetails: {},
};

const reducer = {
    "xShippingDetails/BeginLoadShippingDetails": (draft: Draft<xShippingDetailsType>) => {
        draft.isLoading = true;
    },
    "xShippingDetails/ResetIsUpdatingShippingDetails": (draft: Draft<xShippingDetailsType>, actions: { isUpdating: boolean }) => {
        draft.isUpdating = actions.isUpdating;
    },
    "xShippingDetails/ResetAllShippingDetails": (draft: Draft<xShippingDetailsType>) => {
        draft.warehousesShippingDetails = {};
    },
    "xShippingDetails/CompleteUpdatingWarehouseShippingDetails": (draft: Draft<xShippingDetailsType>, actions: { shippingInfo: ShippingDetailsModel; warehouseId: string, isUpdating: boolean }) => {
        draft.warehousesShippingDetails[actions.warehouseId] = actions.shippingInfo;
        draft.isUpdating = actions.isUpdating;
    },
    "xShippingDetails/CompleteLoadShippingDetails": (draft: Draft<xShippingDetailsType>, actions: { shippingInfo: ShippingDetailsModel; warehouseId: string }) => {
        draft.warehousesShippingDetails[actions.warehouseId] = actions.shippingInfo;
        draft.isLoading = false;
    },
    "xShippingDetails/ResetIsLoadingShippingDetails": (draft: Draft<xShippingDetailsType>, actions: { isLoading: boolean }) => {
        draft.isLoading = actions.isLoading;
    },
    "xShippingDetails/SetInitialShippingDetailsFromCart": (draft: Draft<xShippingDetailsType>, actions: { warehousesShippingDetails: {[warehouseId: string]: ShippingDetailsModel}}) => {
        draft.warehousesShippingDetails = actions.warehousesShippingDetails;
    }, 
    "xShippingDetails/DeleteShippingDetails": (draft: Draft<xShippingDetailsType>, action: { warehouseId: string }) => {
        delete draft.warehousesShippingDetails[action.warehouseId];

    },
}
const xShippingDetails = createTypedReducerWithImmer(initialState, reducer);

(reducers as any).xShippingDetails = xShippingDetails;

export type xShippingDetailsState = {
    xShippingDetails: xShippingDetailsType;
} & ApplicationState;

type xShippingDetailsReducers = {
    xShippingDetails: typeof xShippingDetails;
};

export type xShippingDetailsActions = Parameters<xShippingDetailsReducers[keyof xShippingDetailsReducers]>[1] | AnyAction;
